
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 14 30","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M14 9.714H9V6.601c0-1.17.968-1.442 1.513-1.442H14V.019L9.25 0C4.126 0 2.961 3.834 2.961 6.288v3.426H0v5.297h2.962V30H9V15.01h4.396L14 9.715z","fill":"#232323","fill-rule":"evenodd"}})])
          )
        }
      }
    